import { apiSlice } from '../apiSlice';

export interface MonthlyMePredictionResponse {
  id: string;
  userId: string;
  prediction: string;
  ratings?: {
    overall: number;
    wealth_investments: number;
    career_profession: number;
    education: number;
    health: number;
    relationships: number;
    children: number;
  };
  type: 'Monthly';
  status: 'Success' | 'Pending' | 'Failed';
  period: 'CurrentMonth' | 'NextMonth';
  videoId?: string | null;
  rashi?: string;
  createdAt?: string;
  expiresAt?: string;
}

export interface PredictionChartMeta {
  location: string;
  time: string;
}

export interface PredictionChart {
  chartId: string;
  chartType: 'north' | 'south';
  imageUrl: string;
  startDate: string;
  endDate: string;
  meta: PredictionChartMeta;
}

export interface PredictionPeriodResponse {
  period: 'NextWeek' | 'NextMonth' | 'CurrentWeek' | 'CurrentMonth';
  startDate: string;
  endDate: string;
  charts: PredictionChart[];
}

export const mePredictionMonthlyApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMyMonthlyPrediction: builder.query<MonthlyMePredictionResponse, { userId: string; language?: string }>({
      query: ({ userId, language }) => ({
        url: `/admin/users/${userId}/predictions`,
        method: 'GET',
        params: { type: 'Monthly', period: 'CurrentMonth', ...(language ? { language } : {}) },
      }),
    }),

    getMyNextMonthlyPrediction: builder.query<MonthlyMePredictionResponse, { userId: string; language?: string }>({
      query: ({ userId, language }) => ({
        url: `/admin/users/${userId}/predictions`,
        method: 'GET',
        params: { type: 'Monthly', period: 'NextMonth', ...(language ? { language } : {}) },
      }),
    }),

    getPredictionByPeriod: builder.query<
      PredictionPeriodResponse,
      'NextWeek' | 'NextMonth' | 'CurrentWeek' | 'CurrentMonth'
    >({
      query: (period) => ({
        url: '/predictions',
        method: 'GET',
        params: { period },
      }),
    }),
  }),
});

export const {
  useLazyGetMyMonthlyPredictionQuery,
  useLazyGetMyNextMonthlyPredictionQuery,
  useLazyGetPredictionByPeriodQuery,
} = mePredictionMonthlyApi;
